import { breakpoint } from '@carvana/helios-layout';
import { background, body, border, brand, spacing, text } from '@carvana/helios-styles';
import styled from 'styled-components';
import getAssetUrl from '../../utilities/getAssetUrl';

const Background = styled.div`
  display: flex;
  background: linear-gradient(
      181deg,
      rgba(0, 76, 143, 0.95) 2.49%,
      rgba(16, 107, 199, 0.95) 19.5%,
      rgba(34, 139, 230, 0.95) 39.05%,
      rgba(59, 201, 219, 0.7) 58.77%,
      rgba(153, 233, 242, 0.27) 85.48%
    ),
    rgba(255, 255, 255, 0.9);
  justify-content: center;
  height: 540px;
  position: relative;

  ${breakpoint.sm`
    height: 566px;
  `};

  ${breakpoint.md`
    background: linear-gradient(180deg, rgba(0, 76, 143, 0.95) 2.08%, rgba(16, 107, 199, 0.95) 22.11%, rgba(34, 139, 230, 0.95) 45.12%, rgba(59, 201, 219, 0.7) 68.33%, rgba(153, 233, 242, 0.3) 99.76%), rgba(255, 255, 255, 0.95);
    height: 480px;
  `}

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    background-image: linear-gradient(to bottom, transparent, white);
    opacity: 1;
    height: 12%;
    width: 100%;
    z-index: 1;

    ${breakpoint.lg`
      height: 30%;
    `}
  }
`;

const BackgroundImage = styled.div`
  background-image: url('${getAssetUrl('/images/banner.svg')}');
  background-repeat: no-repeat;
  transform: scaleX(-1);
  width: 100%;
  position: absolute;
  top: 1;
  left: 0;
  height: 500px;
  z-index: 1;
  margin-top: 40px;

  ${breakpoint.sm`
    background-size: 100%;
    height: 524px;
    transform: initial;
  `}

  ${breakpoint.md`
    background-image: url('${getAssetUrl('/images/banner-lg.svg')}');
    height: 440px;
    background-size: cover;
  `};
`;

const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-width: 327px;
  margin: 0 auto;
  margin-top: 40px;
  position: relative;
  z-index: 2;

  ${breakpoint.sm`
    max-width: 704px;
    margin-top: 80px;
  `};

  ${breakpoint.md`
    flex-direction: row;
    margin: 0;
    max-width: 1056px;
    margin: 0 32px;
    width: 1056px;
  `}
`;

const CardWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  min-width: 327px;
  width: 100%;
  z-index: 10;

  ${breakpoint.sm`
    min-width: unset;
  `};

  ${breakpoint.md`
    justify-content: flex-end;
    margin: 0;
    padding: 0;
  `}
`;

const Card = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: ${spacing.xl};
  padding-bottom: 8px;
  border: 1px solid ${border.weak};
  border-radius: 8px;
  background-color: ${background.default};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  ${breakpoint.sm`
    width: 704px;
  `}

  ${breakpoint.md`
    width: 456px;
  `}
`;

const Title = styled.h1`
  ${brand.sm};
  color: ${text.inverse};
  font-weight: 900;
  margin-bottom: 16px;
  max-width: 300px;
  text-align: center;
  text-transform: uppercase;

  ${breakpoint.sm`
    max-width: initial;
  `}

  ${breakpoint.md`
    ${brand.lg};
    max-width: 600px;
    text-align: left;
    width: 488px;
  `}
`;

const Description = styled.p`
  ${body.regular.lg};
  color: ${text.inverse};
  margin-bottom: 24px;
  max-width: 300px;
  text-align: center;

  ${breakpoint.sm`
    margin-bottom: 52px;
  `}

  ${breakpoint.md`
    ${body.regular.xl};
    max-width: 460px;
    text-align: left;
  `}
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${breakpoint.md`
    align-items: flex-start;
    margin-right: 56px;
    width: 488px;
  `}
`;

export {
  Background,
  BackgroundImage,
  Card,
  CardWrapper,
  Container,
  Description,
  TextContainer,
  Title
};
